/**
 * Feedback API
 *
 * Endpoints:
 *   POST api/v1/feedback - submitFeedback
 */
import { apiClientPostRequest } from '../lib/backendRequest';

const feedbackApi = (accessToken) => ({
  /**
   * Submit feedback for a delivered order owned by the authenticated user.
   *
   * @param {string} externalId Order external id (e.g. "PL-123456").
   * @param {'good'|'bad'} rating
   * @param {string} [text] Free-text feedback. Optional.
   */
  async submitFeedback(externalId, rating, text = '') {
    try {
      await apiClientPostRequest(
        'api/v1/feedback',
        {
          external_id: externalId,
          rating,
          text: text || undefined,
        },
        {
          Authorization: `Token ${accessToken}`,
        },
      );

      return { data: true };
    } catch (e) {
      if (e.code === 404) {
        return { error: 'We could not find this order. Please check the link from your email.' };
      }
      if (e.code === 401) {
        return { error: 'You need to be signed in to the same account that placed this order.' };
      }
      if (e.body && e.body.message) {
        return { error: e.body.message };
      }
      return { error: 'Something went wrong while sending your feedback. Please try again.' };
    }
  },
});

export default feedbackApi;
